"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimePicker = void 0;
var react_1 = __importStar(require("react"));
var luxon_1 = require("luxon");
var Select_1 = require("./Select");
var TimePicker = function (_a) {
    var onChange = _a.onChange, min = _a.min, max = _a.max, timezone = _a.timezone, _b = _a.step, step = _b === void 0 ? 15 : _b, nativeProps = __rest(_a, ["onChange", "min", "max", "timezone", "step"]);
    var defaultValue = (0, react_1.useMemo)(function () {
        var val = nativeProps.defaultValue
            ? luxon_1.DateTime.fromISO(nativeProps.defaultValue)
            : luxon_1.DateTime.local();
        return timezone ? val.setZone(timezone) : val;
    }, [nativeProps, timezone]);
    var options = (0, react_1.useMemo)(function () {
        var initial = min || defaultValue.startOf('hour').set({ hour: 0 });
        var final = max || defaultValue.startOf('hour').set({ hour: 23, minute: 59 });
        if (timezone) {
            initial = initial.setZone(timezone);
            final = final.setZone(timezone);
        }
        var current = initial;
        var opts = [];
        while (current <= final) {
            opts.push({
                label: current.toFormat('h:mm a ZZZZ'),
                value: current.toUTC().toISO(),
            });
            current = current.plus({ minutes: step });
        }
        return opts;
    }, [defaultValue, step, min, max, timezone]);
    return (react_1.default.createElement(Select_1.Select, __assign({}, __assign({ defaultValue: defaultValue.toUTC().toISO(), onChange: function (e) {
            var ts = luxon_1.DateTime.fromISO(e.target.value);
            onChange(timezone ? ts.setZone(timezone) : ts);
        } }, nativeProps), { options: options })));
};
exports.TimePicker = TimePicker;
//# sourceMappingURL=TimePicker.js.map